import { render, staticRenderFns } from "./SrModalPageStepper.vue?vue&type=template&id=32631682"
import script from "./SrModalPageStepper.vue?vue&type=script&lang=js"
export * from "./SrModalPageStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports